import React, { useMemo } from 'react';
import { DATE_FORMAT_URL, DATE_SHORT_FORMAT_WITH_DAYOFWEEK } from '../../../../data/constants/datetime';
import { useItemsFilteredByDate } from '../../../../data/hooks/datetime/useItemsFilteredByDate';
import { useEvent } from '../../../../data/hooks/eventHooks';
import { useI18n } from '../../../../data/hooks/i18nHooks';
import { useVisibleSchedule } from '../../../../data/hooks/schedule/useVisibleSchedule';
import { eventMomentFactory } from '../../../../data/misc/eventMomentFactory';
import Scrollable from '../../../elements/Scrollable';
import TopBarEvent from '../../../elements/TopBar/TopBarEvent';
import Screen from '../../Screen';
import GroupedProgramItems from '../common/GroupedProgramItems';
import slugify from '../common/slugifyCategory';
import HeaderCentered from '../../../elements/headers/HeaderCentered/HeaderCentered';

const EventScheduleCategoryScreen = (props) => {
    const { eventId, date, categorySlug } = props,
        event = useEvent(eventId),
        i18n = useI18n(),
        visibleItems = useVisibleSchedule(eventId),
        todayVisibleItems = useItemsFilteredByDate(event, visibleItems, date, DATE_FORMAT_URL),
        category = useMemo(() => {
            return todayVisibleItems
                .map((item) => item.display_category)
                .filter((i) => i)
                .find((cat) => slugify(cat) == categorySlug);
        }, [todayVisibleItems]),
        items = useMemo(() => {
            return todayVisibleItems.filter((item) => item.display_category == category);
        }, [category, todayVisibleItems]),
        formattedDate = eventMomentFactory(event, date).format(DATE_SHORT_FORMAT_WITH_DAYOFWEEK);

    console.log('DATE', date);

    const header = (
        <div>
            <TopBarEvent event={event} returnURL="../..">
                {category}
            </TopBarEvent>
            <HeaderCentered>{formattedDate}</HeaderCentered>
        </div>
    );
    return (
        <Screen header={header}>
            <Scrollable>
                <GroupedProgramItems event={event} items={items} />
            </Scrollable>
        </Screen>
    );
};

export default (props) => <EventScheduleCategoryScreen {...props.match.params} />;
